export interface IShareLinkRequest {
  shareAccessType: ShareAccessTypeEnum;
  shareDocs: {
    docId?: string;
    fileIds?: string[];
  }[];
}

export interface IShareLinkResponse {
  shareLink: string;
  shareId: string;
  customerId: string;
  projectId: string;
  shareAccessType: ShareAccessTypeEnum;
  docsCount: number;
  isSingleFileShare: boolean;
  notFoundFileIds?: string[];
  notFoundDocIds?: string[];
}

export enum ShareAccessTypeEnum {
    PUBLIC = 'public',
    PROTECTED = 'protected',
}